__webpack_require__.p = "/intranet/build/";